import { render, staticRenderFns } from "./loginsTwo.vue?vue&type=template&id=60476a54&"
import script from "./loginsTwo.vue?vue&type=script&lang=js&"
export * from "./loginsTwo.vue?vue&type=script&lang=js&"
import style0 from "./loginsTwo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./loginsTwo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports